import { useCallback, useEffect, useState } from 'react'
import { useFeatureFlagV2 } from '@/api/kubik/monolith'
import { FEATURE_FLAGS } from '@/constants/feature-flags'

export const useCaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState('')
  const [captchaVisible, setCaptchaVisible] = useState(false)
  const [isCaptchaEnabled, setIsCaptchaEnabled] = useState(true)
  const [resetCaptchaKey, setResetCaptchaKey] = useState(0)

  const handleResetCaptcha = () => setResetCaptchaKey(prev => prev + 1)

  const handleChallengeHidden = useCallback(() => setCaptchaVisible(false), [])

  const {
    data,
    isFetched: isFetchedFeatureFlag,
    isFetching: isFetchingFeatureFlag,
    isSuccess,
  } = useFeatureFlagV2({ flagKey: FEATURE_FLAGS.USE_CAPTCHA })

  useEffect(() => {
    if (isSuccess) {
      setIsCaptchaEnabled(Boolean(data?.result))
    }
  }, [data?.result, isSuccess])

  return {
    captchaVisible,
    isCaptchaEnabled,
    captchaToken,
    isFetchedFeatureFlag,
    isFetchingFeatureFlag,
    setCaptchaToken,
    setCaptchaVisible,
    handleChallengeHidden,
    setIsCaptchaEnabled,
    handleResetCaptcha,
    resetCaptchaKey,
  }
}
